export default __webpack_public_path__ + "static/media/Snd_ClowerD.79fb3f3b.mp3";